module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    //LOCAL CONNECTION
    // API_URL: "http://localhost:5216/api/v1/admin",

    // PRODUCTION CONNECTION
    API_URL: "https://api.kamacaash.com/api/v1/admin",
  },
};
